import { type User, UserRole } from '@scoring/types';
import { useApiMutation } from '../../queries/useApiMutation';
import { produce } from 'immer';
import { queryKeys } from '../../queries/queryKeys';
import { setQueryDataSafe } from '../../utils/queryUtilities';
import { post } from '../../queries';

export const useAssignUserRoleMutation = () => {
    const mutation = useApiMutation<{ userId: string; role: UserRole }>({
        mutationFn: async ({ userId, role }) => post(`users/${userId}/roles/${role}`, { userId, role }),
        onManualCacheUpdate: async (queryClient, _response, args) => {
            setQueryDataSafe<User[]>(queryClient, queryKeys.users.list(), (previous) =>
                produce(previous, (draft) => {
                    const index = draft.findIndex((ath) => ath.id === args.userId);
                    if (index !== -1 && !draft[index].roles.includes(args.role)) draft[index].roles.push(args.role);
                })
            );
            // the auth store reads the single-user query
            await queryClient.invalidateQueries({ queryKey: queryKeys.users.single(args.userId) });
        },
    });

    return mutation;
};
